const fields = {
  config: { columns: 2 },
  fields: [
    {
      name: "tmpId",
      column: 1,
      type: "unvisible",
    },
    {
      name: 'daysCount',
      label: 'Ilość dni',
      column: 1,
      mandatory: true,
      type: 'number',
    },
    {
      name: 'discount',
      label: 'Rabat',
      column: 2,
      suffix: "%",
      maxValue: 100,
      scale: 2,
      mandatory: true,
      type: 'number',
    },
  ],
};

export default fields;
